export default __webpack_public_path__ + "static/media/img-2.92c25d48.jpg";